<template>
  <div style="position: relative;">
    <Button class="btn-offerte btn-tutorial" icon="pi pi-question-circle" @click="visible = true" severity="success" v-tooltip="'Clicca per visualizzare il tutorial'"/>
    <Dialog v-model:visible="visible" header="Tutorial" :dismissableMask="true" modal :draggable="false" style="min-width: 300px;">
      <Carousel :value="slides" :numVisible="1">
        <template #item="slotProps">
          <div :class="['h-full',{'flex align-items-center': windowSize < 700}]">
            <div v-if="windowSize > 700" class="border-1 surface-border border-round text-center py-5 px-3">
              <div class="mb-2">
                <img :src="slotProps.data.name" :alt="slotProps.data.name" :class="['shadow-2 w-'+(windowSize < 1400 ? slotProps.data.size+3 : slotProps.data.size)]"/>
              </div>
            </div>

            <p class="m-2 text-center"><strong>{{ slotProps.data.description }}</strong></p>
          </div>
        </template>
      </Carousel>
    </Dialog>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  props: {
    slides: { type: Array, default: () => [] },
    windowSize: { type: Number, required: true }
  },
  setup() {
    const visible = ref(false)
    return { visible }
  }
}
</script>

<style scoped>
  .btn-tutorial{
    position: absolute;
    top: 5px;
    right: 5px;
  }
  .btn-offerte{
    border-radius: 50% !important;
    background-color: rgb(233, 233, 233);
    color: rgb(105, 105, 105);
    border: 1px solid rgba(255, 255, 255, 0);
  }
  .btn-offerte:hover {
    background-color: rgb(233, 233, 233);
    color: rgb(105, 105, 105);
    border-color: #2196F3;
  }
</style>
